// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-25 22:24:01

export default {
  "id": "chicken-wild-run",
  "slug": "chicken-wild-run",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/54866edc07d34e5d84d9e48cf4443923-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/54866edc07d34e5d84d9e48cf4443923/",
  "releaseDate": "2025-03-25",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Chicken Wild Run",
      "description": "Aim for the goal while collecting coins! Tap to change direction left and right. When your stamina runs out, the game is over. Get a kiss from a cute girl and become invincible! In invincible mode, you can bounce off obstacles. If you collect 10 mysterious bottles, the coins on the road will turn into high-scoring diamonds for a certain period of time.",
      "instructions": "Tap to turn left or right",
      "genres": [
        "Agility",
        "Casual"
      ],
      "tags": [
        "chicken",
        "cowboy",
        "cute",
        "run",
        "running"
      ]
    },
    "zh-CN": {
      "title": "疯狂鸡跑",
      "description": "瞄准目标同时收集金币！点击改变左右方向。当你的耐力耗尽时，游戏结束。得到一个可爱女孩的吻，你将变得无敌！在无敌模式下，你可以从障碍物上弹跳。如果你收集了10个神秘的瓶子，路上的金币将在一定时间内变成高分钻石。",
      "instructions": "点击转向左或右",
      "genres": [
        "敏捷性",
        "休闲"
      ],
      "tags": [
        "小鸡",
        "牛仔",
        "可爱",
        "跑",
        "奔跑"
      ]
    },
    "zh-TW": {
      "title": "雞狂奔跑",
      "description": "朝目標進發，同時收集硬幣！點擊以改變方向左右。當你的體力耗盡時，遊戲結束。獲得可愛女孩的一個吻，你將變得無敵！在無敵模式下，你可以從障礙物彈跳。如果你收集到10個神秘的瓶子，路上的人幣將會在一段時間內轉變為高分紅寶石。",
      "instructions": "點擊以轉向左或右",
      "genres": [
        "敏捷性",
        "休闲"
      ],
      "tags": [
        "雞",
        "牛仔",
        "可愛",
        "跑",
        "奔跑"
      ]
    },
    "zh-HK": {
      "title": "雞野生狂奔",
      "description": "目標是達到目標同時收集硬幣！點擊以改變左右方向。當你的體力耗盡時，遊戲結束。獲得可愛女孩一吻成為無敵！無敵模式中，你可以從障礙物彈跳過去。如果收集到10個神秘瓶，路上的硬幣將在一段時間內變成高分钻石。",
      "instructions": "輕觸以轉左或右",
      "genres": [
        "靈巧度",
        "休閒"
      ],
      "tags": [
        "雞",
        "牛仔",
        "可愛",
        "跑",
        "奔跑"
      ]
    },
    "ja": {
      "title": "チキン・ワイルド・ラン",
      "description": "ゴールを目指しながらコインを集めろ！タップで左右に方向を変えろ。体力が切れるとゲームオーバーだ。可愛い女の子にキスをすると無敵になる！無敵モードでは障害物を弾き飛ばせる。10個の神秘的なボトルを集めると、道の上のコインが一定時間高得点のダイヤモンドに変化する。",
      "instructions": "タップして左回りまたは右回りに進む",
      "genres": [
        "アギリティ",
        "カジュアル"
      ],
      "tags": [
        "チキン",
        "カウボーイ",
        "可愛い",
        "走る",
        "走行中"
      ]
    },
    "ko": {
      "title": "치킨 월드 런",
      "description": "목표에 향해 쿠킹하며 동전을 모아라! 좌우 방향을 바꾸려면 탭을 누르세요. 피로도가 다 떨어지면 게임이 끝납니다. 귀여운 여자아이로부터 키스를 받으면 무적이 됩니다! 무적 모드에서는 장애물을 반대로 뛰어넘을 수 있습니다. 10개의 미스터리 병을 모으면 일정 기간 동안 도로上的 동전이 높은 점수를 주는 보석으로 변합니다.",
      "instructions": "왼쪽 또는 오른쪽으로 돌리려면 탭하세요",
      "genres": [
        "민첩성",
        "캐주얼"
      ],
      "tags": [
        "치킨",
        "캐나리",
        "귀여운",
        "달리기",
        "달리다"
      ]
    },
    "fr": {
      "title": "Course sauvage de poulet",
      "description": "Visitez le but tout en collectant des pièces ! Tapez pour changer de direction à gauche et à droite. Lorsque votre endurance est épuisée, la partie est finie. Recevez un baiser d'une jolie fille et devenez invincible ! En mode invincible, vous pouvez rebondir sur les obstacles. Si vous collectez 10 bouteilles mystérieuses, les pièces sur la route deviendront des diamants à haut score pendant une période déterminée.",
      "instructions": "Touchez pour tourner à gauche ou à droite",
      "genres": [
        "Agilité",
        "Occasionnel"
      ],
      "tags": [
        "poulet",
        "cow-boy",
        "mignon",
        "courir",
        "courant"
      ]
    }
  }
};
